import { FilterGroupLogicPayload } from '../../../types';
import { FilterGroup, FilterLogic, FilterSource } from '../types';

type Params = {
  groupLogic: FilterLogic;
  filterGroups: FilterGroup[];
};

const getFieldKeyOrId = (
  source: FilterSource,
  key: string,
  id: string,
): string => {
  if (source === FilterSource.FIELD) {
    return id.toString();
  }

  return key.toString();
};

export const formatFilterGroupsForPayload = ({
  groupLogic,
  filterGroups,
}: Params): FilterGroupLogicPayload => ({
  group_logic: groupLogic,
  filters: filterGroups.map((item) => ({
    ...item,
    conditions: item.conditions
      .filter((condition) => condition.field && condition.operation)
      .map((condition) => ({
        source: condition.field.source,
        field: getFieldKeyOrId(
          condition.field.source,
          condition.field.key,
          condition.field.id,
        ),
        operation: condition.operation,
        value: condition.value,
      })),
  })),
});
